import DeviceRegistrationFirstForm from "../../../forms/DeviceRegistrationForms/Registration/DeviceRegistrationFirstForm";
import {message} from "antd";
import "../DeviceBaseRegistration.css";

const DeviceRegistrationFirst = () => {
    const handleClear = (form) => {
        form.resetFields();
        localStorage.removeItem("deviceRegistrationStep1")
        localStorage.removeItem("deviceRegistrationStep2")
        message.info("Form cleared");
    };

    const uploadProps = {
        name: "file",
        multiple: false,
        accept: ".pdf",
        maxCount: 1,
        beforeUpload: () => false, // Prevent auto-uploading
    };

    return (
        <DeviceRegistrationFirstForm
            handleClear={handleClear}
            uploadProps={uploadProps}
        />
    );
};

export default DeviceRegistrationFirst;
